import React from 'react'
import { useRouter } from 'next/router'
import { logout } from 'src/core/helpers'
import { useTranslation } from 'next-i18next'
import { useAppDispatch } from 'src/app/hooks'
import { CustomModal, CustomTitle } from 'src/components'
import { resetUserPersonalDataState } from 'src/features'

const EmailChangedModal: React.FC<{ isModalVisible: boolean }> = ({ isModalVisible }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useRouter()

  const handleCancel = () => {
    logout(router)
    dispatch(resetUserPersonalDataState())
  }

  return <CustomModal
    title={t('settings.EmailChanged')}
    footer={null}
    open={isModalVisible}
    onCancel={handleCancel}
  >
    <CustomTitle label={t('settings.EmailChangedLabel')} />
  </CustomModal>
}
export default EmailChangedModal
